import { c as _c } from "react/compiler-runtime";
interface PhotoOverlayProperties {
  className?: string;
  index: number;
  registerOverlay: (index: number) => (node: HTMLDivElement | null) => void;
}
export function PhotoOverlay(t0) {
  const $ = _c(6);
  const {
    index,
    registerOverlay,
    className
  } = t0;
  let t1;
  if ($[0] !== index || $[1] !== registerOverlay) {
    t1 = registerOverlay(index);
    $[0] = index;
    $[1] = registerOverlay;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className || $[4] !== t1) {
    t2 = <div ref={t1} data-loaded="false" className={className} />;
    $[3] = className;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}